type MailboxReadinessFields = {
  active?: boolean
  backoffReason?: string
  backoffUntil?: string
  canGraphSend?: boolean
  currentDailyCap?: number
  dailyLimit?: number
  graphEligible?: boolean
  graphSendEligible?: boolean
  graphSendNotReadyReasons?: string[]
  graphSendReady?: boolean
  graphSendReadinessReasons?: string[]
  graphSendReasons?: string[]
  graphSendStatus?: string
  isGraphEligible?: boolean
  pausedAt?: string
  pausedReason?: string
  retryAt?: string
  sendEligible?: boolean
  targetDailyCap?: number
  warmupStage?: string
}

const normalizedValue = (value?: unknown) =>
  value === undefined || value === null
    ? ""
    : String(value).trim().toLowerCase()

const blockedStatusTokens = [
  "backoff",
  "blocked",
  "cooldown",
  "disabled",
  "graph_ineligible",
  "graph_not_ready",
  "graph not eligible",
  "ineligible",
  "not_eligible",
  "not eligible",
  "not_ready",
  "paused",
  "retry",
  "suspended",
  "tenant_mail_send_not_ready",
]

const statusIsBlocked = (value?: unknown) => {
  const normalized = normalizedValue(value)
  return Boolean(
    normalized &&
      blockedStatusTokens.some((token) => normalized.includes(token)),
  )
}

const graphReasons = (mailbox: MailboxReadinessFields) =>
  [
    ...(mailbox.graphSendReadinessReasons || []),
    ...(mailbox.graphSendNotReadyReasons || []),
    ...(mailbox.graphSendReasons || []),
  ].filter(Boolean)

export const mailboxIsPausedForSending = (mailbox: MailboxReadinessFields) =>
  Boolean(
    mailbox.pausedAt ||
      mailbox.pausedReason ||
      mailbox.backoffReason ||
      mailbox.backoffUntil ||
      mailbox.retryAt ||
      statusIsBlocked(mailbox.warmupStage) ||
      statusIsBlocked(mailbox.graphSendStatus),
  )

export const mailboxIsGraphBlocked = (mailbox: MailboxReadinessFields) =>
  Boolean(
    mailbox.active === false ||
      mailbox.graphSendEligible === false ||
      mailbox.graphEligible === false ||
      mailbox.isGraphEligible === false ||
      mailbox.canGraphSend === false ||
      mailbox.sendEligible === false ||
      mailboxIsPausedForSending(mailbox) ||
      graphReasons(mailbox).some(statusIsBlocked),
  )

export const mailboxCountsAsGraphReady = (mailbox: MailboxReadinessFields) =>
  mailbox.graphSendReady === true && !mailboxIsGraphBlocked(mailbox)

export const mailboxSendCapacity = (mailbox: MailboxReadinessFields) => {
  if (!mailboxCountsAsGraphReady(mailbox)) return 0

  return (
    mailbox.currentDailyCap ?? mailbox.targetDailyCap ?? mailbox.dailyLimit ?? 0
  )
}
